import QuartzManage from './QuartzManage.vue'

QuartzManage.install = function (Vue) {
    Vue.component(QuartzManage.name, QuartzManage)
}

import QuartzEdit from './QuartzEdit.vue'

QuartzEdit.install = function (Vue) {
    Vue.component(QuartzEdit.name, QuartzEdit)
}

export {QuartzManage, QuartzEdit}
